<template>
  <div class="reset-password-page">
    <div v-if="!isResetSubmitted">
      <h1>Uw wachtwoord herstellen</h1>
      <div class="row input-container q-pb-lg">
        Vul hieronder uw gebruikersnaam (e-mailadres) en klik vervolgens op Herstellen. 
      </div>
      <div class="row input-container">
        <q-input
          dense
          outlined
          v-model="username"
          label="Gebruikersnaam / e-mailadres"
          class="search-input pw-reset-input"
          @keydown.enter="submitResetPassword()"
          bg-color="white"
          :rules="[isValidEmail, requiredFieldRule]"
          :bottom-slots="true"
          ref="inputBox"
        >
        </q-input>
        <q-btn
          class="q-ml-md submit-btn"
          flat
          no-caps
          color="white"
          label="Herstellen"
          @click="submitResetPassword"
        />
      </div>
    </div>
    <div v-else class="submitted-page">
      <div class="row justify-center align-center">
        <div class="col-6">
          <div class="submit-heading">
            <i class="las la-2x la-check-circle submitted-icon"></i>
            <label class="submit-label">
              Indien u een bij ons bekend e-mailadres heeft ingevuld, ontvangt u binnen enkele minuten een e-mail met verdere instructies voor het herstel van uw wachtwoord. 
              <br /><br />
              Heeft u niets ontvangen binnen enkele minuten, controleer dan ook uw spamfolder, of neem anders contact op met: 088-20 20 401
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import UserService from '../services/userprofile.service';
export default {
  setup() {
    const isResetSubmitted = ref(false);
    const username = ref('');
    const inputBox = ref(null);
    const submitResetPassword = async () => {
      var isInputValid = inputBox.value.validate();

      if (isInputValid) {
        UserService.requestResetPassword(username);
        isResetSubmitted.value = true;
      }
    };

    return {
      username,
      inputBox,
      submitResetPassword,
      isResetSubmitted,

      requiredFieldRule: [
        (val) => (val && val.length > 0) || 'Veld is verplicht!',
      ],
      isValidEmail(val) {
        const emailPattern = /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;
        return emailPattern.test(val) || 'Ongeldig e-mailadres';
      },
    };
  },
};
</script>
